import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import {ToastsContainer, ToastsStore} from 'react-toasts';
import MenuComponent2 from './MenuComponent2';
// import ReactTablePagination from './PaginationComponent';
import TalkService from '../services/TalkService';
import ReplyDialog from './ReplyDialog';
import couterpart from 'counterpart';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import DatePicker from 'react-datepicker';
import { FaFilter } from 'react-icons/fa';
import { ICON_COLOR } from '../icon';

import "../css/style.css";
import WorkOrderDataService from '../services/WorkOrderDataService';

class TalkList extends Component {
  constructor () {
    super();
    this.reply = React.createRef();

    //let fromDate = new Date(new Date().getTime() - 1*30*24*60*60*1000*1);//1 month
    let fromDate = new Date(new Date().getTime() - 1*7*24*60*60*1000*1);//1 week
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);

    this.state = {
      fromDate: fromDate,
      items: [],
      items2: [],
      columns : [{
          Header: 'Msg',
          Cell: row =>(
            this.linkToView(row.original)
          )
        },{
          Header: 'Người gửi',
          accessor: 'sender'
        },{          
          Header: 'Đơn hàng',
          accessor: 'workOrderNo'
        },{
          Header: 'Ngày tạo',
          accessor: 'createdAt'            
        },{          
          Header: 'Tình trạng',
          Cell:  row =>(
            this.getStatusDescription(row.original)
          )
        },{
          Header: '',
          width: 50,
          Cell: row =>(
            this.linkToReply(row.original)
          )
        },{
          Header: '',
          width: 50,
          Cell: row =>(
            this.linkToClose(row.original)
          )
        }],
      columns2 : [{
            Header: 'Msg',
            accessor: 'msg'
        },{
            Header: 'Gửi tới',
            accessor: 'receiver'
        },{          
            Header: 'Đơn hàng',
            accessor: 'workOrderNo'
        },{
            Header: 'Ngày tạo',
            accessor: 'createdAt'            
        },{          
          Header: 'Tình trạng',
          Cell:  row =>(
            this.getStatusDescription(row.original)
          )
        },{
          Header: '',
          width: 50,
          Cell: row =>(
            this.linkToClose(row.original)
          )
        }]      
    };
  }

  componentDidMount () {
    this.loadTalks()     
  }

  getStatusDescription(talk){
    if (talk.status === 3){
      return(
          <div  className="black-text">{'Close'}</div>
      )
    }

    if (talk.status === 1){
      return(
          <div className="red-text">{'New'}</div>
      )
    }

    if (talk.status === 2){
      return(
          <div className="green-text">{'Open'}</div>
      )
    }

    return talk.status + '';  
  }

  compare(talk1, talk2) {
    let comparison = 0;
    if (talk1.createdAt < talk2.createdAt) {
      comparison = 1;
    } else if (talk1.createdAt > talk2.createdAt) {
      comparison = -1;
    }
    return comparison;
  }

  loadTalks(){
    let vm = this;
    TalkService.retrieveTalkSendToCurrentUser(this.state.fromDate).then(data => {
      if (data instanceof Array){
        if (data.message === undefined){
          data.sort(vm.compare)
          this.setState({ items:  data})
        }else{
          this.setState({ items:  []})
        }
      } else {
        this.setState({ items:  []})
      }
    });
    TalkService.retrieveTalkCreatedByCurrentUser(this.state.fromDate).then(data => {
      if (data instanceof Array){
        if (data.message === undefined){
          data.sort(vm.compare)
          this.setState({ items2:  data})
        }else{
          this.setState({ items2:  []})
          ToastsStore.error(data.message);
        }
      } else {
        this.setState({ items:  []})
      }      
    });      
  }

  handleFromDateChange(date){
    let vm = this;
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      fromDate: sDate                   
    }), () =>{
      vm.loadTalks()
    });
  }  

  navToReply(talk){
    console.log('talk', talk)
    TalkService.updateStatus(talk, 2).then( () => {
      this.reply.current.toggle(talk);
    })
  }

  closeReply(talk){
    let vm = this
    console.log('talk', talk)
    TalkService.updateStatus(talk, 3).then(data => {
      alert(couterpart.translate("msg_updated_ok"));
      vm.loadTalks()
    });
  }  

  linkToReply(talk){
    if (talk.status !== 3){
      return(
          <div className="link-text" onClick={() => {this.navToReply(talk)} }>{ 'Reply'}</div>
      )
    }
    return ''
  }

  linkToView(talk){
    if (talk.status !== 3){
      return(
          <div className="link-text" onClick={() => {this.navToReply(talk)} }>{ talk.msg }</div>
      )
    }
    return ''
  }  

  linkToClose(talk){
    if (talk.status !== 3){
      return(
          <div className="link-text" onClick={() => {this.closeReply(talk)} }>{'Close'}</div>
      )
    }
    return ''
  }

  onPrint(){
    WorkOrderDataService.printBarcode(null);
  }    

  render() {
    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <div className="row">&nbsp;</div>
              <div className="row">
                <label><b>{couterpart.translate('order_date_from')}</b></label>:&nbsp;
                  <DatePicker name="fromDate" 
                    dateFormat="MM/dd/yyyy hh:mm"              
                    selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                    onChange={this.handleFromDateChange.bind(this)}/>&nbsp;&nbsp;
              </div>
              <div className="row">
                <div className="col-6">
                  <label htmlFor="">Gửi tới tôi</label>
                  <ReactTable
                    NoDataComponent={() => null} 
                    // PaginationComponent={ReactTablePagination}
                    previousText={"<"}
                    nextText={">"}
                    data={this.state.items}
                    columns={this.state.columns}
                    defaultPageSize = {10}
                    showPageSizeOptions = {true}
                    pageSizeOptions = {[3, 5, 10, 20]}
                    getTrProps={(state, rowInfo, column) => { 
                      if (rowInfo && rowInfo.row) {
                      return {
                        onClick: (e) => {
                          this.setState({
                            selected: rowInfo.index,
                            itemId: rowInfo.original.id
                          })
                        },
                        style: {
                          background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                          color: rowInfo.index === this.state.selected ? 'white' : 'black'
                        }
                      }
                      }else{
                        return {}
                      }
                    }
                  }
                  />
                </div>
                <div className="col-6">
                  <label htmlFor="">Tôi gửi đi</label>
                  <ReactTable
                    NoDataComponent={() => null} 
                    // PaginationComponent={ReactTablePagination}
                    previousText={"<"}
                    nextText={">"}
                    data={this.state.items2}
                    columns={this.state.columns2}
                    defaultPageSize = {10}
                    showPageSizeOptions = {true}
                    pageSizeOptions = {[3, 5, 10, 20]}
                    getTrProps={(state, rowInfo, column) => { 
                      if (rowInfo && rowInfo.row) {
                      return {
                        onClick: (e) => {
                          this.setState({
                            selected: rowInfo.index,
                            itemId: rowInfo.original.id
                          })
                        },
                        style: {
                          background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                          color: rowInfo.index === this.state.selected ? 'white' : 'black'
                        }
                      }
                      }else{
                        return {}
                      }
                    }
                  }
                  />
                </div>
              </div>
              <ReplyDialog ref={this.reply}  reloadTalks={this.loadTalks.bind(this) }/>
          </div>      
    )
  }
}

export default TalkList;